module.exports = __webpack_public_path__ + "static/img/egg_g_15.62544b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_15.png
// module id = hgEK
// module chunks = 1